import { render, staticRenderFns } from "./changeGoodBadType.vue?vue&type=template&id=84538094&"
import script from "./changeGoodBadType.vue?vue&type=script&lang=js&"
export * from "./changeGoodBadType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports